import styled, { css } from 'styled-components';
import { Link } from '../../../common/components/Link';
import { CloseIcon } from '../../../common/components/icons/CloseIcon';
import { ThemeColours } from '../../styles/ThemeColours';
import { FontWeight, PRESSABLE, FONT_STACK, FontSize } from '../../styles/constants';
import { onMobile } from '../../styles/onMobile';
import { LinkButton } from '../Button/LinkButton/LinkButton';
import { CTADot } from '../CTADot';
import BackArrow from '../icons/BackArrow.svg';
import { ClickableLogo } from './ClickableLogo/ClickableLogo';
import { HamburgerIcon } from './HamburgerIcon/HamburgerIcon';

export const Overlay = styled.div`
  background-color: ${ThemeColours.mono800};
  height: 100vh;
  opacity: 0.4;
`;

export const BackArrowIcon = styled(BackArrow)`
  color: ${ThemeColours.black};
  cursor: pointer;
  flex: 0 0 auto;
  margin-inline-end: 8px;
  [dir='rtl'] & {
    transform: scaleX(-1);
  }
`;

export const NewBackArrowIcon = styled(BackArrow)`
  color: ${ThemeColours.mono700};
  cursor: pointer;
  flex: 0 0 auto;
  margin-inline-end: 12px;
  [dir='rtl'] & {
    transform: scaleX(-1);
  }
`;

export const StyledHamburgerIcon = styled(HamburgerIcon)`
  margin-inline-start: 8px;
`;

export const NewStyledHamburgerIcon = styled(HamburgerIcon)<{ isSearchMultiLine?: boolean }>`
  margin-inline-start: 8px;
  ${({ isSearchMultiLine }) =>
    isSearchMultiLine &&
    css`
      position: absolute;
      right: 20px;
      top: 15px;
    `}
`;

export const SearchBarCloseIcon = styled(CloseIcon)`
  color: ${ThemeColours.mono700};
  height: 24px;
  left: 16px;
  position: absolute;
  top: 16px;
  width: 24px;
`;

export const StyledHamburgerIconExp = styled(HamburgerIcon)`
  margin-inline-end: 8px;
  margin-inline-start: 0px;
`;

export const HamburgerContainer = styled.div`
  position: relative;
`;

export const NewHamburgerContainer = styled.div<{ isSearchMultiLine?: boolean }>`
  position: relative;
  ${({ isSearchMultiLine }) =>
    isSearchMultiLine &&
    css`
      bottom: 68px;
      right: 4px;
    `}
`;

export const StyledCTADot = styled(CTADot)`
  height: 8px;
  min-width: 8px;
  position: absolute;
  right: -9px;
  top: 0px;
`;

export const CloseSearchButton = styled.a.attrs({ 'data-testid': 'closeSearchButton' })`
  color: ${ThemeColours.mono600};
  cursor: pointer;
  flex: 0 0 auto;
  font-weight: ${FontWeight.SEMI_BOLD};
`;

export const StyledClickableLogo = styled(ClickableLogo)`
  flex: ${props => (props.textLogo ? '1' : '0')};
  ${onMobile} {
    margin-inline-end: 8px;
  }
  margin-inline-end: 32px;
`;

export const EmptyLogoContainer = styled.div`
  align-items: center;
  display: flex;
  flex: 0 0 auto;
  justify-content: center;
`;

export const HomepageEmptyLogoContainer = styled.div`
  flex: 1;
`;

export const Login = styled(LinkButton)`
  font-size: 16px;
  height: 36px;
  margin-inline-start: 8px;
  max-width: 70px;
`;

export const UserAvatarView = styled(Link)`
  background: none;
  margin: 0 0 0 8px;
  position: relative;
  text-decoration: none;
  width: 32px;
`;

export const Avatar = styled.div.attrs({ title: 'Avatar' })`
  ${PRESSABLE};
  align-items: center;
  border-radius: 100%;
  box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.15);
  display: flex;
  height: 32px;
  justify-content: center;
  overflow: hidden;
  width: 32px;
`;

export const Initials = styled.div`
  align-items: center;
  background-color: ${ThemeColours.buttonPrimaryFill};
  color: ${ThemeColours.buttonPrimaryText};
  display: flex;
  font-size: 16px;
  font-weight: ${FontWeight.REGULAR};
  height: 100%;
  justify-content: center;
  text-transform: uppercase;
  width: 100%;
`;

export const SearchBarInstructionText = styled.div`
  ${FONT_STACK}
  color: ${ThemeColours.mono800};
  font-size: ${FontSize.SMALL};
  left: 50%;
  position: absolute;
  top: 24px;
  transform: translateX(-50%);
`;
